<template>
  <!-- Mini Lens report: header + three metric chips. -->
  <div>
    <div class="flex items-center gap-2 px-3.5 py-2 border-b border-border-normal">
      <div class="w-4 h-4 rounded bg-neutral-900 flex-shrink-0" />
      <BaseText
        type="label"
        size="xs"
        class="text-text-muted"
      >
        Lens · Foreplay (Demo)
      </BaseText>
      <BaseText
        type="body"
        size="xs"
        class="ml-auto text-text-subdued flex-shrink-0"
      >
        Top Performing
      </BaseText>
    </div>
    <div class="flex items-stretch gap-2 px-3.5 py-3">
      <div
        v-for="(metric, index) in metrics"
        :key="metric.label"
        class="scene-metric flex-1 rounded-lg px-2 py-2"
        :style="{ animationDelay: `${160 + index * 80}ms` }"
      >
        <BaseText
          type="body"
          size="xs"
          class="text-text-subdued"
        >
          {{ metric.label }}
        </BaseText>
        <BaseText
          type="label"
          size="sm"
          class="text-text-loud mt-0.5"
        >
          {{ metric.value }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LensReportScene',
  data () {
    return {
      metrics: [
        { label: 'Spend', value: '$48.2k' },
        { label: 'ROAS', value: '3.4x' },
        { label: 'Hook rate', value: '28%' }
      ]
    }
  }
}
</script>

<style scoped>
.scene-metric {
  background-color: theme('colors.neutral.25');
  animation: scene-metric-in 320ms ease-out both;
}
@keyframes scene-metric-in {
  from {
    opacity: 0;
    transform: translateY(3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .scene-metric {
    animation: none;
  }
}
</style>
